import Vue from 'vue';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store/store';

Vue.use(Vuelidate);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.config.disableHostCheck = true;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
